import { graphql } from "../../generated"

export const GET_USERS = graphql(`
    query GetUsers($first: Int, $SubjectFilter: SubjectFilter) {
        users(first: $first, filter: $SubjectFilter) {
            nodes {
                id
                role
                organizationMemberships {
                    id
                    managedAccess
                }
                identity {
                    fullName
                    firstName
                    lastName
                    email
                    active
                }
                organization {
                    id
                    name
                }
            }
        }
    }
`)
